import type { PricingComponent } from '@growthdept/blocks/gift-pricing';

export interface PricingComponentCardProps {
  title: string;
  component: PricingComponent;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  quantity: number;
}

export function PricingComponentCard({
  title,
  component,
  value,
  onChange,
  disabled = false,
  quantity,
}: PricingComponentCardProps) {
  return (
    <section
      className={`rounded-lg border border-bmade-200 p-3 dark:border-bmade-800 ${
        disabled ? 'opacity-55' : ''
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <h3 className="text-xs font-semibold text-bmade-900 dark:text-white">{title}</h3>
        <output className="text-sm font-semibold text-bmade-950 dark:text-white">
          {value.toFixed(0)}%
        </output>
      </div>
      <input
        aria-label={`Brutomarge ${title}`}
        type="range"
        min="0"
        max="70"
        step="1"
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(Number(event.target.value))}
        className="mt-2 w-full accent-accent-500"
      />
      {disabled && <p className="text-[10px] text-bmade-400">Geen kosten in dit onderdeel</p>}
      <dl className="mt-2 space-y-1 border-t border-bmade-100 pt-2 text-[10px] dark:border-bmade-800">
        <AmountRow label="Kostprijs" value={component.cost} quantity={quantity} />
        <AmountRow label="Brutowinst" value={component.margin_euros} quantity={quantity} />
        <AmountRow label="Verkoop excl. btw" value={component.selling_excl_btw} quantity={quantity} strong />
        <AmountRow label={`Btw (${component.btw_rate}%)`} value={component.btw_euros} quantity={quantity} />
        <AmountRow label="Verkoop incl. btw" value={component.selling_incl_btw} quantity={quantity} strong />
      </dl>
    </section>
  );
}

function AmountRow({
  label,
  value,
  quantity,
  strong = false,
}: {
  label: string;
  value: number;
  quantity: number;
  strong?: boolean;
}) {
  return (
    <div className={`grid grid-cols-[1fr_auto] gap-3 ${strong ? 'font-semibold text-bmade-950 dark:text-white' : 'text-bmade-500 dark:text-bmade-400'}`}>
      <dt>{label}</dt>
      <dd className="text-right">
        EUR {value.toFixed(2)}
        <span className="ml-1 font-normal text-bmade-400">
          · EUR {(value / Math.max(1, quantity)).toFixed(2)} / pakket
        </span>
      </dd>
    </div>
  );
}
